RivalIQ.apps.SocialPosts.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Activity = RivalIQ.views.LayoutView.mixin({
        className: 'post-activity',
        template: '#socialPostsActivityTemplate',
        childView: RivalIQ.apps.Dashboard.views.Widget,

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            normalizeHeights: RivalIQ.apps.Dashboard.mixins.NormalizeHeights,
            PostTagsReload: App.mixins.PostTagsReload,
            companySetChangeReload: RivalIQ.apps.Shell.mixins.CompanySetChangeReload
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        regions: {
            postRate: '.x-posts',
            engRate: '.x-eng',
            table: '.x-table'
        },

        loadData: function (callback) {
            const me = this;

            me.dashboardModel.metric.fetch().done(function (metric) {
                me.model = metric;
                callback();
            });
        },

        onBeforeRenderLoaded: function () {
            const me = this;

            me.showTable();
            me.showSummaries();
        },

        showTable: function () {
            const me = this;

            const widget = me.dashboardModel.getWidget('table');
            me.table.showWidget(widget, {
                className: `table-double-header ${me.dashboardModel.isExporting() ? 'x-table-container' : 'table-responsive'}`
            });

            me.listenTo(widget, 'change:sortOrder', function (model, sortOrder) {
                me.setProps('sortOrder', sortOrder, {
                    silent: true
                });
            });

            me.listenTo(widget, 'change:orderBy', function (model, orderBy) {
                me.setProps('orderBy', orderBy, {
                    silent: true
                });
            });
        },

        showSummaries: function () {
            const me = this;

            me.postRate.showWidget(me.dashboardModel.getWidget('postsCount'));
            me.engRate.showWidget(me.dashboardModel.getWidget('engRate'));
        },

        templateHelpers: function () {
            const me = this;
            return {
                url: function () {
                    return me.dashboardModel.getPath({
                        widgetId: 'activity'
                    });
                }
            };
        }
    });

    function getTableMetrics(props) {

        const me = this;
        const metric = me.metric;

        const companyId = props.focusCompanyId;
        const companyHighlighter = function (data) {
            const highlight = (Number(data) === companyId ? 'text-highlight' : '');
            return `metric-table-cell ${highlight}`;
        };

        const metrics = [
            metric.build({
                property: 'name',
                dimensions: ['companyId'],
                sortable: false,
                cellView: function () {
                    return RivalIQ.views.metric.CompanyRank;
                },
                mustInclude: function (data) {
                    return Number(_.head(data)) === companyId;
                },
                sort: function () {
                    return function (a, b) {
                        // NOTE always sort company names asc
                        return RivalIQ.utils.sort.company(a, b, -1);
                    };
                }
            }),
            metric.build({
                dimensions: ['companyId'],
                property: 'count',
                header: {
                    className: 'text-center'
                },
                className: companyHighlighter
            }),
            metric.build({
                property: 'avg_engagement_rate_per_post',
                dimensions: ['companyId'],
                header: {
                    className: 'col-sm-3 col-md-5 text-center'
                },
                className: function (data) {
                    return (Number(data) === companyId ? 'bar-focus-company' : 'bar-competitor');
                }
            })
        ];

        if (props.expandMetrics) {
            // we're in details mode, show more metrics.
            // we want avg_engagement_rate_per_post to always be last
            const insertionIndex = metrics.length - 1;
            metrics.splice(insertionIndex, 0,
                metric.build({
                    dimensions: ['companyId'],
                    property: 'count / period',
                    header: {
                        className: 'text-center'
                    },
                    className: companyHighlighter
                }),
                metric.build({
                    dimensions: ['companyId'],
                    property: 'engagement_total',
                    header: {
                        className: 'text-center'
                    },
                    className: companyHighlighter
                })
            );
        }

        return new RivalIQ.collections.MetricDefinitions(metrics);
    }

    const Widget = RivalIQ.apps.Dashboard.models.Widget;
    const ActivityWidget = Widget.extend({
        title: 'Activity & Engagement',
        getExportTitle: App.utils.exportTitle,
        getExportSubtitle: App.utils.exportSubtitle,
        getPptSubtitle: App.utils.pptSubtitle,
        getSlideElements: App.utils.getSlideElements,
        description: function () {
            const me = this;
            const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');
            return RivalIQ.str('social_posts_activity_info', postWord);
        },
        view: Activity,
        pdfView: App.views.PdfPanel,
        pngView: App.views.PngPanel,
        exportFormats: [
            RivalIQ.enums.exportFormat.PDF,
            RivalIQ.enums.exportFormat.PNG,
            RivalIQ.enums.exportFormat.PPT,
            RivalIQ.enums.exportFormat.CSV
        ],
        getFilename: function () {
            const me = this;
            const companyId = me.getProp('focusCompanyId');
            const company = RivalIQ.state.landscape.getCompanyById(companyId);
            return RivalIQ.export.filename.base({
                title: 'Activity',
                companyName: company.get('name')
            });
        },
        propsToSerializeForExport: App.utils.widgetExportProps,
        csvExportProps: function () {
            const me = this;

            return {
                type: 'metric',
                metric: me.metric.build({
                    limit: -1,
                    dimensions: ['companyId']
                }).serialize()
            };
        },
        processProps: function (props) {
            const me = this;
            _.defaults(props, {
                orderBy: [2, 0],
                limit: 8,
                filter: true,
                showDescriptions: true
            });

            if (!me.metric) {
                me.metric = new RivalIQ.models.MetricDefinition({
                    concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS.id,
                    descriptionDimensions: ['channel']
                });
            }

            App.utils.updateMetric(me.metric, props);
            props.startDate = moment.utc(props.timePeriod.mainPeriodStart).format('YYYY-MM-DD');
            props.endDate = moment.utc(props.timePeriod.mainPeriodEnd).format('YYYY-MM-DD');

            return props;
        },
        viewMorePath: function () {
            const me = this;
            // TODO this should not require a specific instanceid
            return me.getPath({
                instanceId: 'activity'
            });
        },
        widgetDefinitions: function () {
            const me = this;
            const props = me.getProps();

            const rowFilter = function (row) {
                // Keep the row if any of the data values are not zero
                return !_.some(_.tail(row), function (datum) {
                    return Boolean(_.last(datum));
                });
            };

            const postWord = RivalIQ.data.channels.get(props.channel).get('postName');
            const audienceName = me.getProp('channel') === 'facebook' ? 'Page Fan' : 'Follower';

            return [
                {
                    instanceId: 'table',
                    widgetId: RivalIQ.enums.widgetTypes.SOCIAL_POSTS_POST_AGGREGATES_TABLE,
                    metricsCollection: getTableMetrics.call(me, props),
                    rowFilter: rowFilter,
                    neverFilter: true
                },
                {
                    instanceId: 'postsCount',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: me.metric.build({
                        name: `Your ${_.capitalize(postWord)}s in Period`,
                        description: RivalIQ.strings.activity_activity_description,
                        companyId: props.focusCompanyId,
                        dimensions: ['companyId']
                    }),
                    submetric: me.metric.build({
                        property: 'count / companyId.count',
                        name: 'Landscape Avg.'
                    })
                },
                {
                    instanceId: 'engRate',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: me.metric.build({
                        name: `Your Eng. Rate by ${audienceName}`,
                        abbreviatedName: 'Your Eng. Rate',
                        description: RivalIQ.str('social_posts_engagement_rate_by_follower', postWord, audienceName.toLocaleLowerCase(), audienceName),
                        companyId: props.focusCompanyId,
                        property: 'avg_engagement_rate_per_post',
                        dimensions: ['companyId']
                    }),
                    submetric: me.metric.build({
                        name: `${_.capitalize(postWord)} Avg.`,
                        property: 'avg_engagement_rate_per_post'
                    })
                }
            ];
        },
        filter: function () {
            const me = this;
            return !RivalIQ.props.channelAccess(me.getProps());
        },
        allowPageBreaks: function () {
            const me = this;

            const limit = me.getProp('limit');
            return limit === -1;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SOCIAL_POSTS_ACTIVITY, ActivityWidget);
});
